import update from 'immutability-helper'
import clsx from 'clsx'
import React, {useRef} from 'react'
import Box from '@mui/material/Box'
import {faArrowsAltH} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import useStyles from './fill-in-the-blanks/styles'
import Button from './fill-in-the-blanks/button'
import Premise from './fill-in-the-blanks/premise'
import Preview from '../preview-questions/fill-in-the-blanks/index.jsx'

export default function FillInTheBlanksQuestion (props) {

  const {index, context, question, onPropertyChange} = props

  const {translate, quizQuestions = {}} = context
  const classes = useStyles()
	const config = {readonly: false}
  const premiseText = question.premise.text || ''
  const phrases = question.answer.phrases || []
	
  async function handlePremiseChanged (text) {
    const premise = {text}
    const answer = {phrases: text.split(' ').map(phrase => ({phrase, blanked: false}))}
    props.updateProperties && props.updateProperties({id: question.id, premise, answer, textpremise: text}, {premise: {$set: premise}, answer: {$set: answer}, textpremise: {$set: text}})
  }

  async function handleJoinPhrases (id, tail) {
    const joinPhrases = {phrases: {
      $splice: [[id, 1]],
      [id - 1]: {$apply: ({phrase, blanked}) => ({blanked, phrase: `${phrase} ${tail}`})}
    }}

    const answer = update(question.answer, joinPhrases)
    props.updateProperties && props.updateProperties({id: question.id, answer}, {answer: joinPhrases})
  }

  async function handleBlankWord (id, blanked) {
    const blankPhrase = {phrases: {[id]: {blanked: {$set: blanked}}}}
    const answer = update(question.answer, blankPhrase)
    props.updateProperties && props.updateProperties({id: question.id, answer}, {answer: blankPhrase})
  }
	
  return (
    <Box className={clsx(classes.root, "question", "true-or-false")}>
      <Box className={clsx(classes.premise, "premise")}>
        <Box className="label">{translate('premise')}:</Box>
        <Box className="instructions">{translate('fill-in-the-blanks-premise-instructions')}</Box>
        <Premise
          context={context}
          premise={premiseText}
          onPremiseChange={handlePremiseChanged}
        />
      </Box>
      <Box className={clsx(classes.answer, "answer")}>
        <Box className="label">{translate('blanks')}:</Box>
        <Box className="instructions">{translate('fill-in-the-blanks-instructions')}</Box>
        <Button  className="button" onClick={() => handlePremiseChanged(premiseText)}>
          {translate('reset')}
        </Button>
        <Box className="phrases">
          {phrases.map(({phrase, blanked}, index) =>(
            <React.Fragment key={index}>
              {index > 0 && (
                <Box className="joiner" onClick={() => handleJoinPhrases(index, phrase)}>
                <FontAwesomeIcon icon={faArrowsAltH} />
              </Box>
              )}
              <Box className={clsx("phrase", {blanked})} onClick={() => handleBlankWord(index, !blanked)}>
                {phrase}
              </Box>
            </React.Fragment>
          ))}
        </Box>
     </Box>
      <Box className={clsx(classes.preview, "preview")}>
        <Preview context={context} question={question} />
      </Box>
    </Box>
  )
}
